(function () {
  var SECTION_SELECTOR = '.oddit-section-product-parts-accordion';
  var TRIGGER_SELECTOR = '.oddit-section-product-parts-accordion__trigger';
  var ITEM_SELECTOR = '.oddit-section-product-parts-accordion__item';
  var PANEL_SELECTOR = '.oddit-section-product-parts-accordion__panel';
  var PANEL_INNER_SELECTOR = '.oddit-section-product-parts-accordion__panel-inner';

  function setPanelHeight(item, open) {
    var panel = item.querySelector(PANEL_SELECTOR);
    if (!panel) return;
    var inner = panel.querySelector(PANEL_INNER_SELECTOR);
    if (!inner) return;

    if (open) {
      panel.style.height = inner.offsetHeight + 'px';
    } else {
      // Set to current height first (to enable transition from that point),
      // then collapse to 0 on the next frame.
      panel.style.height = panel.offsetHeight + 'px';
      // Force reflow so the browser registers the explicit height before we change it.
      void panel.offsetHeight;
      panel.style.height = '0px';
    }
  }

  function initItem(item) {
    var panel = item.querySelector(PANEL_SELECTOR);
    if (!panel) return;
    if (item.classList.contains('is-open')) {
      // Use 'auto' initially? No — we need a pixel value to start transitions from.
      var inner = panel.querySelector(PANEL_INNER_SELECTOR);
      if (inner) panel.style.height = inner.offsetHeight + 'px';
    } else {
      panel.style.height = '0px';
    }

    // When the open transition finishes, release the explicit height so the
    // panel can reflow on resize / content changes.
    panel.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'height') return;
      if (item.classList.contains('is-open')) {
        panel.style.height = 'auto';
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.odditPartsAccordionInit === 'true') return;
    section.dataset.odditPartsAccordionInit = 'true';

    var items = section.querySelectorAll(ITEM_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      initItem(items[i]);
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest(TRIGGER_SELECTOR);
      if (!trigger || !section.contains(trigger)) return;

      var clickedItem = trigger.closest(ITEM_SELECTOR);
      if (!clickedItem) return;

      // Always keep one item open — clicking the already-open item is a no-op.
      if (clickedItem.classList.contains('is-open')) return;

      var wasOpen = false;

      // First pass: for any currently open item, pin its height so the
      // transition can animate from that pixel value. Do this synchronously
      // in a single read/write batch so all closes start on the same frame.
      var allItems = section.querySelectorAll(ITEM_SELECTOR);
      for (var i = 0; i < allItems.length; i++) {
        var it = allItems[i];
        if (it.classList.contains('is-open')) {
          var p = it.querySelector(PANEL_SELECTOR);
          if (p) p.style.height = p.offsetHeight + 'px';
        }
      }

      // Force reflow so explicit heights are committed before class changes.
      void section.offsetHeight;

      // Second pass: toggle states and animate to target heights in the same frame.
      for (var j = 0; j < allItems.length; j++) {
        var item = allItems[j];
        var shouldOpen = (item === clickedItem) && !wasOpen;

        if (shouldOpen) {
          item.classList.add('is-open');
          var openTrigger = item.querySelector(TRIGGER_SELECTOR);
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'true');

          var panel = item.querySelector(PANEL_SELECTOR);
          var inner = panel ? panel.querySelector(PANEL_INNER_SELECTOR) : null;
          if (panel && inner) {
            panel.style.height = inner.offsetHeight + 'px';
          }
        } else {
          item.classList.remove('is-open');
          var closeTrigger = item.querySelector(TRIGGER_SELECTOR);
          if (closeTrigger) closeTrigger.setAttribute('aria-expanded', 'false');

          var closePanel = item.querySelector(PANEL_SELECTOR);
          if (closePanel) closePanel.style.height = '0px';
        }
      }
    });
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
